import React, { FC } from 'react';
import { CancelConfirmModal as CancelConfirmModalUDL } from './component';
import { CancelConfirmModal as CancelConfirmModalLegacy } from './component.legacy';
import { convertLegacyModalSize } from '../../utils/legacyModalSize';

import { Props } from './types';

export const CancelConfirmModal: FC<Props> = props => {
  if (props.renderAsLegacy) {
    return <CancelConfirmModalLegacy {...props} />;
  }
  return <CancelConfirmModalUDL {...props} size={props.size && convertLegacyModalSize(props.size)} />;
};
